export const LANDING_ASSETS = {
  dashboardLight: "./assets/images/landing-1/dashboard Ligth.png",
  dashboardDark: "./assets/images/landing-1/dashboard Dark.png",
  dashboard: "assets/images/landing-1/dashboard.png",
  caseLight: "assets/images/landing-1/cases ligth.png",
  caseDark: "assets/images/landing-1/case-dark.png",
  cases: "assets/images/landing-1/cases.png",
  claims: "assets/images/landing-1/calims.png",
  damagedInventories: "assets/images/landing-1/damagedInventories.png",
  caseReport: "assets/images/landing-1/case report.png",
  faqs: "assets/images/landing-1/faqs.png",
  translate: "assets/images/landing-1/translate.png",
} as const;
